import React, {createContext, useContext, useState} from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, {AlertColor} from "@mui/material/Alert";

type AlertContextType = {
    showAlert: (message: string, severity: AlertColor) => void;
};

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const AlertProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const [alert, setAlert] = useState<{ message: string; severity: AlertColor; open: boolean }>({
        message: "",
        severity: "success",
        open: false,
    });

    const showAlert = (message: string, severity: AlertColor) => {
        setAlert({message, severity, open: true});
    };

    return (
        <AlertContext.Provider value={{showAlert}}>
            {children}
            <Snackbar open={alert.open} autoHideDuration={3000} onClose={() => setAlert((prev) => ({...prev, open: false}))}>
                <MuiAlert elevation={6} variant="filled" severity={alert.severity} onClose={() => setAlert((prev) => ({...prev, open: false}))}>
                    {alert.message}
                </MuiAlert>
            </Snackbar>
        </AlertContext.Provider>
    );
};

export const useAlert = (): AlertContextType => {
    const context = useContext(AlertContext);
    if (!context) {
        throw new Error("useAlert must be used within an AlertProvider");
    }
    return context;
};